export default __webpack_public_path__ + "static/eow_manufacturer-9b263966b93f0f771754fa5b3b7b5a31.png";